import { useMemo } from 'react'
import { Text, Pluralize } from '@workwhile/ui'
import { useWorkerStats } from './useWorkerStats'

export function FillStatusText(props: {
  shift: Parameters<typeof useWorkerStats>[0]
}) {
  const { shift } = props
  const { workers, workersNeeded, shouldShowConfirmed, confirmed, clockedIn } =
    useWorkerStats(shift)

  const fillStatusText = useMemo(() => {
    return (
      <>
        Filled {Math.min(workers.length, workersNeeded)} of{' '}
        <Pluralize
          count={workersNeeded}
          oneText={'worker'}
          manyText={'workers'}
        />
        {shouldShowConfirmed && confirmed > 0
          ? `, ${confirmed} Confirmed`
          : null}
        {clockedIn > 0 ? `, ${clockedIn} Clocked In` : null}
      </>
    )
  }, [workers, workersNeeded, shouldShowConfirmed, confirmed, clockedIn])

  return <Text color={'lightText'}>{fillStatusText}</Text>
}
